import { SxProps, Theme } from '@mui/material';

import { QueueItemStatus } from '../models/enums/QueueItemStatus';
import { QueueType } from '../models/enums/QueueType';

export type StatusMeta = {
    label: string;
    color: string;
    bg: string;
    borderColor: string;
    progressColor: string;
};

export type QueueTypeMeta = {
    label: string;
    color: string;
    bg: string;
};

export const STATUS_META: Record<QueueItemStatus, StatusMeta> = {
    [QueueItemStatus.Waiting]: {
        label: 'Waiting',
        color: '#5c6bc0',
        bg: '#ede7f6',
        borderColor: '#7986cb',
        progressColor: '#7986cb',
    },
    [QueueItemStatus.MissingParams]: {
        label: 'Missing Params',
        color: '#e65100',
        bg: '#fff3e0',
        borderColor: '#ffa726',
        progressColor: '#ffa726',
    },
    [QueueItemStatus.Processing]: {
        label: 'Processing',
        color: '#0277bd',
        bg: '#e1f5fe',
        borderColor: '#29b6f6',
        progressColor: '#29b6f6',
    },
    [QueueItemStatus.Error]: {
        label: 'Error',
        color: '#c62828',
        bg: '#ffebee',
        borderColor: '#ef9a9a',
        progressColor: '#ef5350',
    },
    [QueueItemStatus.Success]: {
        label: 'Success',
        color: '#2e7d32',
        bg: '#e8f5e9',
        borderColor: '#66bb6a',
        progressColor: '#66bb6a',
    },
};

export const QUEUE_TYPE_META: Record<QueueType, QueueTypeMeta> = {
    [QueueType.Unknown]: { label: 'Unknown', color: '#757575', bg: '#f5f5f5' },
    [QueueType.UploadSeismic2D]: { label: 'Seismic 2D', color: '#1565c0', bg: '#e3f2fd' },
    [QueueType.UploadSeismic3D]: { label: 'Seismic 3D', color: '#0277bd', bg: '#e1f5fe' },
    [QueueType.UploadShapefile]: { label: 'Shapefile', color: '#2e7d32', bg: '#e8f5e9' },
    [QueueType.UploadTiff]: { label: 'TIFF', color: '#6a1b9a', bg: '#f3e5f5' },
    [QueueType.UploadGrid]: { label: 'Grid', color: '#e65100', bg: '#fff3e0' },
    [QueueType.CompositeProfile]: { label: 'Composite Profile', color: '#ad1457', bg: '#fce4ec' },
};

export const actionButtonSx: SxProps<Theme> = {
    textTransform: 'none',
    fontSize: 12,
    borderColor: '#c5cae9',
    color: '#3949ab',
    '&:hover': {
        borderColor: '#3949ab',
        backgroundColor: '#f0f4ff',
    },
};

export const STATUS_DISPLAY_ORDER: QueueItemStatus[] = [
    QueueItemStatus.Success,
    QueueItemStatus.Processing,
    QueueItemStatus.Waiting,
    QueueItemStatus.Error,
    QueueItemStatus.MissingParams,
];
